import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABanner({
  title = "Ready to switch to solar?",
  subtitle = "Join 12,000+ homes & businesses already saving with CNGTPL Solar.",
  primaryLabel = "Get Free Consultation",
  primaryTo = "/contact",
  secondaryLabel = "Calculate Savings",
  secondaryTo = "/calculator",
}) {
  return (
    <section
      className="relative overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(rgba(15,23,42,0.85), rgba(30,58,138,0.9)), url(https://static.prod-images.emergentagent.com/jobs/af236e4b-6d37-4c12-98e2-7d0d973c0359/images/25919be159f26eac880d2a41d95d6374fd77adc2aa793c3cfffa6b57baaa5cc7.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="cta-banner"
    >
      <div className="container-narrow py-16 lg:py-24 text-center text-white">
        <div className="badge-eco bg-blue-600/20 text-blue-300 border-blue-600/40 mb-5">
          Start Your Solar Journey
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold tracking-tight mb-4 max-w-3xl mx-auto">
          {title}
        </h2>
        <p className="text-base sm:text-lg text-slate-200 max-w-2xl mx-auto mb-8">{subtitle}</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to={primaryTo} className="btn-primary" data-testid="cta-primary-btn">
            {primaryLabel} <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to={secondaryTo} className="btn-outline bg-white/10 text-white border-white/40 hover:bg-white/20" data-testid="cta-secondary-btn">
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
